import { Modal } from "components/ui/modals/Modal/Modal"
import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import { ButtonWarning } from "components/ui/buttons/ButtonWarning/ButtonWarning"
import { useCallback } from "react"
import { useChangeUserRole, useUsers } from "hooks/api/user/user.hook"
import { useMessage } from "hooks/message.hook"
import { isAxiosError } from "helpers/utils.helper"
import styles from "./ChangeRoleModal.module.scss"

const { modalButtos, question, warning } = styles

type Props = {
	isModalOpen: boolean
	userAction: { id: number; newRole: string }
	setModalOpen: (value: boolean) => void
	record: { name: string }
}

export const ChangeRoleModal = ({ isModalOpen, userAction, setModalOpen, record }: Props) => {
	const { mutate: changeUserRoleMutation } = useChangeUserRole()
	const { refetch: refetchUsers } = useUsers()
	const { success: successMessage, error: errorMessage } = useMessage()

	// Making request and change user role
	const setUserRole = useCallback(() => {
		changeUserRoleMutation(userAction, {
			onSuccess: () => {
				refetchUsers()
				successMessage(`${record.name} is now an ${userAction.newRole}`)
				setModalOpen(false)
			},
			onError: (e) => {
				if (isAxiosError(e)) errorMessage("Something went wrong, please try again later")
			},
		})
	}, [changeUserRoleMutation, userAction, refetchUsers, successMessage, record.name, setModalOpen, errorMessage])

	return (
		<Modal title="Confirm role change" width={600} isModalOpen={isModalOpen} setModalClose={() => setModalOpen(false)}>
			<p className={question}>
				Are you sure you want to change the role of <strong>{record.name}</strong> to{" "}
				<strong>{userAction.newRole}</strong>?
			</p>
			<p className={warning}>
				This action will modify the user's permissions and may affect their access to certain features. Please confirm
				to proceed with this change.
			</p>
			<div className={modalButtos}>
				<ButtonPrimary onClick={() => setModalOpen(false)}>Cancel</ButtonPrimary>
				<ButtonWarning onClick={() => setUserRole()}>Confirm</ButtonWarning>
			</div>
		</Modal>
	)
}
